/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Inspectors_ImageInputs */



/**
* | output |
* | --- |
* | "Seafarer in a hard hat on deck beside the mooring ropes" |
*
* @param {Team_Inspectors_ImageInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_inspectors_image = /** @type {((inputs?: Team_Inspectors_ImageInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Inspectors_ImageInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("在甲板系泊缆旁戴安全帽的海员")
	return /** @type {LocalizedString} */ ("Seafarer in a hard hat on deck beside the mooring ropes")
});